import type { SlideProps } from "@/engine/app/offsite-config";

const ROWS = [
  {
    mythos: "Excel-Makro, das Zellen füllt",
    realitaet: "System, das aus Beispielen Muster lernt",
  },
  {
    mythos: "Wenn-Dann-Regel im Workflow",
    realitaet: "Modell, das auch neue, unbekannte Fälle einordnet",
  },
  {
    mythos: "Texterkennung, die nur abtippt (OCR)",
    realitaet: "KI, die versteht, was in dem Schreiben gemeint ist",
  },
  {
    mythos: "Suchmaschine mit festen Treffern",
    realitaet: "Sprachmodell, das eine Antwort formuliert",
  },
];

export function Slide05WasIstKI(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Grundlagen</div>
        <h1 className="deck-title rise rise-2">
          Was ist KI — <br />
          <span className="accent">und was nicht?</span>
        </h1>
        <p className="deck-sub rise rise-3">
          Nicht alles, was automatisch läuft, ist künstliche Intelligenz.
        </p>
      </header>

      <div className="status-grid rise rise-4">
        <div className="status-headers">
          <div className="neg">Keine KI (aber trotzdem nützlich)</div>
          <div className="pos">KI</div>
        </div>
        {ROWS.map((r) => (
          <div key={r.mythos} className="status-row">
            <div className="status-cell neg">
              <span className="status-mark neg">✕</span>
              <span className="status-text">{r.mythos}</span>
            </div>
            <div className="status-cell pos">
              <span className="status-mark pos">✓</span>
              <span className="status-text">{r.realitaet}</span>
            </div>
          </div>
        ))}
      </div>

      <footer className="deck-foot">
        <span>Faustregel: Regeln werden programmiert — KI wird trainiert.</span>
      </footer>
    </div>
  );
}
